<template>
    <swiper class="swiper contacts-swiper" :options="swiperOption">
        <swiper-slide  v-for="(site, index) in sites" :key="index" class="contacts-swiper__single">
            <div class="lg:flex justify-between">
                <div class="w-full lg:pr-20">
                    <div class="flex justify-between">
                        <div class="info-container w-full">
                            <img :src="images.locationIcon" alt="icon localização" class="location-icon">
                            <p class="
                                sm:text-lead-sm
                                md:text-lead-md
                                tracking-lead-sm
                                md:tracking-lead-md
                                text-gray
                                uppercase
                                font-normal
                                md:font-extrabold
                                my-2
                                lg:my-4">
                                lojas
                            </p>
                            <h1>{{ site.name }}</h1>
                            <p class="address">{{ site.address.street + ' ' + site.address.door + ', ' + site.address.postal_code + ' ' + site.address.locality }}</p>
                        </div>
                        <div class="controllers-container"></div>
                    </div>
                    <p class="meal">Almoço</p>
                    <div class="flex justify-between">
                        <p class="days">Terça-feira a Domingo</p>
                        <p class="hours">Das 12h às 16h</p>
                    </div>
                    <p class="meal">Jantar</p>
                    <div class="flex justify-between">
                        <p class="days">Segunda-feira a Domingo</p>
                        <p class="hours">Das 18h30 às 22h30</p>
                    </div>
                    <a :href="'https://www.google.com/maps/place/' + site.address.latitude + ',' + site.address.longitude" target="_blank" class="btn-bg text-center">Ver no Google Maps</a>
                </div>
                <div>
                    <img :src="images.store" :alt="site.name" class="mt-8 mx-auto lg:mt-0 lg:mr-0 contacts-swiper__image">
                </div>
            </div>
        </swiper-slide>
        <div class="controllers-wrapper">
            <div class="swiper-button-prev swiper-button-orange" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-orange" slot="button-next"></div>
        </div>

    </swiper>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.css'

    // import locationIcon from '../../svg/ic_location_orange.svg'

    export default {
        name: 'swiper-contacts',
        title: 'Fade effect',
        props:{
            sites: {
                required: true
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                items: [
                    {
                        image: 'https://www.nit.pt/wp-content/uploads/2019/07/aea6de9cbaee9d2704dcf81f4a194991.jpg',
                        store_name: 'sacavém',
                        address: 'R. Sport Grupo Sacavenense Nº21 A, 2685-010 Lisboa',
                        lunch_days: 'Terça-feira a Domingo',
                        lunch_hours: 'Das 19h às 23h',
                        dinner_days: 'Segunda-feira a Domingo e feriados',
                        dinner_hours: 'Das 19h às 23h',
                        cta_address: 'https://www.google.pt/maps/search/R.+Sport+Grupo+Sacavenense+N%C2%BA21+A,+2685-010+Lisboa/@38.7904155,-9.1084858,17z/data=!3m1!4b1'
                    },
                    {
                        image: 'https://hortodocampogrande.pt/wp-content/uploads/2018/02/sushuathome_bamboo-artifical.jpg',
                        store_name: 'laranjeiras',
                        address: 'Rua Eng. Fernando Vicente Mendes nº 10, 1600-871 Lisboa',
                        lunch_days: 'Terça-feira a Domingo',
                        lunch_hours: 'Das 19h às 23h',
                        dinner_days: 'Segunda-feira a Domingo e feriados',
                        dinner_hours: 'Das 19h às 23h',
                        cta_address: 'https://www.google.pt/maps/place/R.+Eng.+Fernando+Vicente+Mendes+10,+1600-871+Lisboa/@38.7519635,-9.1735407,17z/data=!3m1!4b1!4m5!3m4!1s0xd1933209b0deae7:0xc726c03db07b115e!8m2!3d38.7519593!4d-9.171352'
                    },
                    {
                        image: 'https://media-cdn.tripadvisor.com/media/photo-s/13/44/5c/d1/sushi-at-home.jpg',
                        store_name: 'carcavelos',
                        address: 'Praceta Nº71A, 2775-540 Lisboa',
                        lunch_days: 'Terça-feira a Domingo',
                        lunch_hours: 'Das 19h às 23h',
                        dinner_days: 'Segunda-feira a Domingo e feriados',
                        dinner_hours: 'Das 19h às 23h',
                        cta_address: 'https://www.google.pt/maps/place/Sushi+at+Home+Carcavelos/@38.6963244,-9.3394371,20z/data=!4m8!1m2!2m1!1sPraceta+N%C2%BA71A,+2775-540+Lisboa!3m4!1s0xd1ec9320ac50073:0x65f19fdfa1e2d008!8m2!3d38.6963721!4d-9.3392761'
                    },
                ],
                images: {
                    locationIcon: '../../svg/ic_location_orange.svg',
                    store: '../../img/sushi-store.jpg'
                },
                swiperOption: {
                    effect: 'fade',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
        mounted(){


        }
    }
</script>

<style>

</style>
